import { GatewayActions } from "gql/graphql";
import { FC } from "react";
import { OpenTask } from "../features/open-task";
import { OpenOpportunity } from "../features/open-opportunity";
import { OpenCandidateInterview } from "../features/open-candidate-interview";
import { OpenAbsenceRequest } from "../features/open-absence-request";
import { OpenBusinessTripRequest } from "../features/open-business-trip-request";
import { OpenDynamicApprovingRequest } from "../features/open-dynamic-approving-request";
import { OpenSurvey } from "../features/open-survey";
import { OpenCompanyDocument } from "../features/open-company-document";
import { OpenPerson } from "../features/open-person";
import { OpenUserResetPasswordCode } from "../features/open-user-reset-password-code";
import { OpenWorkConditionsChangeRequest } from "@/modules/gateway/features/open-work-conditions-change-request/open-work-conditions-change-request";
import { OpenResignationRequest } from "@/modules/gateway/features/open-resignation-request/open-resignation-request";
import { OpenExternalSign } from "@/modules/gateway/features/open-external-sign/open-external-sign";
import { RestoreRoute } from "@/modules/gateway/features/restore-route/restore-route";
import { OpenDocumentRegister } from "@/modules/gateway/features/open-document-register";
import { OpenCompensatoryTimeOffRequest } from "@/modules/gateway/features/open-compensatory-time-off-request";
import { OpenWeekendWorkRequest } from "@/modules/gateway/features/open-weekend-work-request";
import { OpenPostForModeration } from "@/modules/gateway/features/open-post-for-moderation";
import { OpenNotificationTemplate } from "@/modules/gateway/features/open-notification-template";
import { OpenBpmProcess } from "@/modules/gateway/features/open-bpm-process";
import { OpenDynamicProcess } from "@/modules/gateway/features/open-dynamic-process";
import { OpenDocumentRegisterTypeFile } from "@/modules/gateway/features/open-document-register-type-file";
import { OpenTriggerAction } from "@/modules/gateway/features/open-trigger-action";

export const gatewayActions: Record<GatewayActions, FC> = {
  [GatewayActions.OpenAbsenceRequest]: OpenAbsenceRequest,
  [GatewayActions.OpenBusinessTripRequest]: OpenBusinessTripRequest,
  [GatewayActions.OpenCandidateInterview]: OpenCandidateInterview,
  [GatewayActions.OpenCompanyDocument]: OpenCompanyDocument,
  [GatewayActions.OpenDynamicApprovingRequest]: OpenDynamicApprovingRequest,
  [GatewayActions.OpenSurveyParticipant]: OpenSurvey,
  [GatewayActions.OpenTask]: OpenTask,
  [GatewayActions.OpenOpportunity]: OpenOpportunity,
  [GatewayActions.OpenPerson]: OpenPerson,
  [GatewayActions.OpenPostForModeration]: OpenPostForModeration,
  [GatewayActions.OpenUserResetPasswordCodeAction]: OpenUserResetPasswordCode,
  [GatewayActions.OpenResignationRequest]: OpenResignationRequest,
  [GatewayActions.OpenWorkConditionsChangeRequest]:
    OpenWorkConditionsChangeRequest,
  [GatewayActions.OpenExternalSign]: OpenExternalSign,
  [GatewayActions.RestoreRoute]: RestoreRoute,
  [GatewayActions.OpenDocumentRegister]: OpenDocumentRegister,
  [GatewayActions.OpenCompensatoryTimeOffRequest]:
    OpenCompensatoryTimeOffRequest,
  [GatewayActions.OpenWeekendWorkRequest]: OpenWeekendWorkRequest,
  [GatewayActions.OpenNotificationTemplate]: OpenNotificationTemplate,
  [GatewayActions.OpenBpmProcess]: OpenBpmProcess,
  [GatewayActions.OpenDynamicProcess]: OpenDynamicProcess,
  [GatewayActions.OpenDocumentRegisterTypeFile]: OpenDocumentRegisterTypeFile,
  [GatewayActions.OpenTriggerAction]: OpenTriggerAction,
};
